var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.comments),function(comment,index){return _c('CommentBlock',{key:index,attrs:{"comment":comment,"reply-active":_vm.replyActive},on:{"active-reply":function($event){return _vm.$emit('active-reply', $event)}}},[_c('ReplyTree',{attrs:{"parentId":comment.id,"order":_vm.order}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }